import {BaseContainerModel} from '../../base-container.model';
import * as fromDatatype from '../../../datatype-library';

export class ClaimCycleSamplingAnalysisReport2 extends BaseContainerModel {
  claim_cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface; // FE passes if users tick “Include claim line from previous month(s)“
  historical_claim_cycle_hdr_guids: string[];
  branch_guids: string[]; // Empty means select all possible branches under claim cycle
  claim_item_guids: string[];
  claim_statuses: string[];
  claim_types: string[]; // CHARGEABLE,NON_CHARGEABLE
  claim_item_categories: string[];
  is_flag: boolean;
  finance_checking_date_from: fromDatatype.VarcharDatatypeInterface;
  finance_checking_date_to: fromDatatype.VarcharDatatypeInterface;
}
